<template>
<div class="login-page">

	<div class="side"> 
		<!-- <h1>Logística Automotríz</h1> -->
		<div class="bg"></div>
	</div>
	<div class="login-side">
		<div class="login-form">
			<img src="@/assets/img/logo.png" alt="" class="logo">
			<h3>Ingresar</h3>
			<p>Ingresá a tu cuenta con tu usuario y contraseña</p>
			<form @submit.prevent="login">
				<div class="row">
					<div class="col-12">
						<div class="form-group ">
							<label>Email</label>
							<input type="text" class="form-control" placeholder="Email" required v-model="email" >
						</div>
						<div class="form-group  mt-3">
							<label>Contraseña</label>
							<input type="password" class="form-control" placeholder="Contraseña" required v-model="password">
						</div>
						<div class="alert alert-danger" v-if="loginError">
							Datos de acceso incorrectos
						</div>
						<div class="form-group mt-3 text-right">
							<button class="btn btn-primary " type="submit" :disabled="loginIn" >
								<span v-if="loginIn">Ingresando...</span>
								<span v-if="!loginIn">Ingresar</span>
							</button>
						</div>
						
						<hr>
						<p class="text-center"><small>Si tienes problemas para ingresar a tu cuenta, ponete en contacto con nosotros.</small></p>
					</div>
				</div>
				
			</form>
		</div>
	</div>
</div>
</template>

<script>
import axios from 'axios';
import { onLogin } from '../vue-apollo';
import { mapMutations } from 'vuex'


export default {
	name: 'Login',
	data() {
		return {
			email: '',
			password: '',
			loginError:false,
			loginIn:false,
		}
	},
	beforeMount(){
		// this.logout();
	},
	methods: {
		...mapMutations(['authSuccess','logout']),
		login() {
			this.loginError=false;
			if( !this.loginIn && this.email !='' && this.password!='' ){
				this.loginIn = true;
				axios.post('/auth/user/login', { email: this.email, password: this.password, is_user: true })
				.then(request => {
					let access_token = request.data.access_token;
					let logged_user = request.data.user;
					onLogin(this.$apollo.provider.defaultClient, access_token, logged_user).then(() => { 
						this.authSuccess({token:access_token, loggedUser: logged_user});
						this.loginIn = false;
						this.$router.push('/');
					});				
				})
				.catch(() => 
				{
					this.loginError=true;
					this.loginIn = false;
				})
			}
		},
	}
}
</script>

<style scoped>
.login-page{
	height: 100%;
	width: 100%;
	position: absolute;
	top: 0;
	bottom: 0px;
	left: 0px;
	right: 0px;
	display: flex;
}
.login-page .side{
	background-color:#000;
	flex-grow:1;
	position: relative;
}
.login-page .side .bg{
	position: absolute;
	top:0px;
	left:0px;
	width:100%;
	height:100%;
	background-image: url('~@/assets/img/bg-login.jpg');
	background-position: center center;
	background-size: cover;
	background-repeat: no-repeat;
	opacity: .2;
}
.login-page .side h1{
	position: absolute;
	top:0px;
	left:0px;
	color:#fff;
}
.login-page .login-side{
	flex-grow:1;
	display: flex;
	justify-content: center;
	align-items: center;
	
}
.logo{
	width: 200px;
	margin: 0px;
}
.login-form{
	text-align: left;
	background-color: #fff;
	max-width: 350px;
	padding: 16px;
	margin: auto;
}
h3{
	font-weight: 400;
}


</style>
